/**
 * One message from the user in the Zoe thread.
 *
 * Every user turn renders as one of these — including the first, which used
 * to live only in the input box and vanished from the thread the moment a
 * follow-up replaced it. A conversation you cannot read back from the top is
 * not a conversation.
 *
 * A clarification reply renders here too, as the option the user picked:
 * clicking "Orders due on that date…" is the user saying that, and the thread
 * should read that way rather than as an anonymous button press.
 */

import { CornerDownRight } from 'lucide-react';

interface Props {
  text: string;
  /** Set when this message answered a clarification by picking an option. */
  isClarificationReply?: boolean;
}

export default function ZoeUserMessage({ text, isClarificationReply = false }: Props) {
  return (
    <div className="flex justify-end">
      <div className="max-w-85% rounded-2xl rounded-br-md bg-chart-10/30 border border-chart-10/40 px-4 py-2.5">
        {isClarificationReply && (
          <span className="flex items-center gap-1 text-xs uppercase tracking-wide text-chart-10/70 mb-0.5">
            <CornerDownRight className="w-3 h-3" aria-hidden />
            Your choice
          </span>
        )}
        <p className="text-sm text-foreground whitespace-pre-wrap break-words">{text}</p>
      </div>
    </div>
  );
}
